import styled, { from } from 'theme';

export const CardWrapper = styled.div`
  background-color: white;
  border-radius: 0.25rem;
  box-shadow: 0 0 0.5625rem 0 rgba(0, 0, 0, 0.08);
  padding: 2.1875rem 1.6rem;

  ${from('md')} {
    padding: 2.1875rem 2.75rem;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  ${from('md')} {
    margin-bottom: 2.0625rem;
  }

  button {
    flex: 0 0 auto;
  }
`;

export const CardTitle = styled.div`
  flex: 1 1 auto;
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  font-size: ${p => p.theme.variables.fonts.size.bigger1};
  font-weight: ${p => p.theme.variables.fonts.weight.bold};
  line-height: 1;
  color: ${props => props.theme.variables.customColors.leadingColor.base};
`;

export const CardBody = styled.div``;

export const CardItem = styled.div`
  display: flex;
  margin-bottom: 2rem;
  line-height: 1.67;
  flex-direction: column;

  ${from('md')} {
    flex-direction: row;
  }
`;

export const CardItemKey = styled.div`
  flex: 0 0 auto;
  margin: 0 0 0.5rem 0;
  text-align: left;
  font-weight: ${p => p.theme.variables.fonts.weight.bold};
  font-size: ${p => p.theme.variables.fonts.size.smaller1};
  color: ${props => props.theme.variables.customColors.textColor};

  ${from('md')} {
    flex: 0 0 8rem;
    margin: 0 1.5rem 0 0;
    text-align: right;
    flex-direction: row;
  }
`;

export const CardItemValue = styled.div`
  flex: 1 1 auto;
  font-size: ${p => p.theme.variables.fonts.size.smaller1};
  color: ${p => p.theme.variables.customColors.grayMedium};
`;
